import React from 'react'

import { StyledSkeleton } from 'component-library/content/Skeleton/Skeleton.styled'
import { toArray } from 'common/helpers/utils'
export interface Props {
    count?: number
    dark?: boolean
    round?: boolean
    height?: number
    className?: string
}

export const Skeleton: React.FC<Props> = ({ count = 1, dark, round, height, className }) => {
    const array = toArray(count)

    return (
        <span className={`${className} js-skeleton`}>
            {array.map((_: any, i: number) => (
                <StyledSkeleton key={i} dark={dark} round={round} height={height}>
                    &zwnj;
                </StyledSkeleton>
            ))}
        </span>
    )
}
